<div class="content-with-side-menu">
    <div class="row no-gutters">
        <div class="col-md-auto">
            <app-roster-search-criteria
                hznTestId="roster-filters"
                [filters]="filters"
                [searchForm]="searchForm"
            ></app-roster-search-criteria>
        </div>

        <div class="col">
            @if (!noItems && !isBusy) {
                <div
                    class="row no-gutters top-panel height-80 line-height-40 padding-20"
                >
                    <div class="col">
                        <button
                            class="btn btn-success"
                            hznTestId="roster-summary-report"
                            bcClick
                            (clicked)="getSummary()"
                        >
                            {{ "Roster.summaryReport" | translate }}
                        </button>
                        <button
                            class="btn btn-danger hoffset-10"
                            hznTestId="roster-profile-report"
                            bcClick
                            (clicked)="getProfile()"
                        >
                            {{ "Roster.profileReport" | translate }}
                        </button>
                    </div>
                </div>
            }

            <div>
                <bcu-local-spinner
                    [size]="50"
                    [visible]="isBusy"
                ></bcu-local-spinner>

                <div class="list-group list-group-flush">
                    @for (item of items; track item) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start"
                        >
                            <app-roster-item hznTestId="roster-row" [item]="item"></app-roster-item>
                        </div>
                    }

                    @if (noItems && !isBusy) {
                        <div class="no-items-info padding-20" hznTestId="roster-no-items">
                            <span>{{ "Roster.noItems" | translate }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
|
